import { render, staticRenderFns } from "./hallMark.vue?vue&type=template&id=a513bac0&scoped=true"
import script from "./hallMark.vue?vue&type=script&lang=js"
export * from "./hallMark.vue?vue&type=script&lang=js"
import style0 from "./hallMark.vue?vue&type=style&index=0&id=a513bac0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a513bac0",
  null
  
)

export default component.exports